import moment from 'moment';
import React, { useEffect } from 'react';
import { Route } from 'react-router';
import { Redirect, Switch, useLocation, useParams } from 'react-router-dom';
import { DATE_FORMAT_URL } from '../../../data/constants/datetime';
import { useEventSettings } from '../../../data/hooks/events/useEventSettings';
import RelativeRedirect from '../../elements/RelativeRedirect';
import LoadMeetings from '../../loaders/LoadMeetings';
import LoadProgram from '../../loaders/LoadProgram';
import LoadSpeakers from '../../loaders/LoadSpeakers';
import EventScheduleCategoryScreen from '../../screens/EventSchedule/EventScheduleCategoryScreen';
import EventScheduleDefaultRoute from '../../screens/EventSchedule/EventScheduleDefaultRoute';
import { saveDefaultScheduleTab, useDefaultScheduleTab } from '../../screens/EventSchedule/EventScheduleDefaultRoute/defaultScheduleTabTools';
import EventScheduleFilter from '../../screens/EventSchedule/EventScheduleFilterScreen';
import EventScheduleScreen from '../../screens/EventSchedule/EventScheduleScreen';
import { EVENT_SCHEDULE_ALL_AVAILABLE_TABS, EVENT_SCHEDULE_TAB_PROGRAM } from '../../screens/EventSchedule/schedule-header-tabs';
import RedirectOnError from '../../validate/RedirectOnError';
import { meetingRoutes } from '../meetingRoutes';
import speakersRoutes from '../speakersRoutes';
import ScheduleItemRoutes from './scheduleItemRoutes';

const OLD_ROUTES_PART = ['meeting', 'speakers', 'cat'];

function scheduleRoutes(props) {
    const { eventId, date, tab } = props.match.params,
        location = useLocation();

    useEffect(() => {
        saveDefaultScheduleTab(eventId, tab);
    }, [eventId, tab]);

    if (!date || !date.match(/^\d{8}$/) || !moment(date, DATE_FORMAT_URL).isValid()) return <RelativeRedirect to="../.." />;
    if (OLD_ROUTES_PART.includes(tab) || tab.match(/^\d+$/)) return <Redirect to={location.pathname.replace(`${date}/${tab}`, `${date}/${EVENT_SCHEDULE_TAB_PROGRAM}/${tab}`)} />;
    if (!EVENT_SCHEDULE_ALL_AVAILABLE_TABS.includes(tab)) return <RelativeRedirect to="../.." />;

    return (
        <Switch>
            <Route path={`${props.match.path}/filter`} exact component={EventScheduleFilter} />
            <Route path={`${props.match.path}/meeting/:meetingId`} component={meetingRoutes} />
            <Redirect from={`${props.match.path}/meeting`} to={`${props.match.path}`} exact />
            <Route path={`${props.match.path}/speakers`} component={speakersRoutes} />
            <Route path={`${props.match.path}/cat/:categorySlug/:itemId`} component={ScheduleItemRoutes} />
            <Route path={`${props.match.path}/cat/:categorySlug`} exact component={EventScheduleCategoryScreen} />
            <Redirect from={`${props.match.path}/cat`} to={`${props.match.path}`} exact />
            <Route path={`${props.match.path}/:itemId`} component={ScheduleItemRoutes} />
            <Route path={`${props.match.path}`} exact component={EventScheduleScreen} />
            <Redirect to={`${props.match.path}`} />
        </Switch>
    );
}

export default (props) => {
    const { eventId } = useParams(),
        settings = useEventSettings(eventId),
        defaultTab = useDefaultScheduleTab(eventId);

    if (settings?.disable_schedule) return <RelativeRedirect to=".." />;

    return (
        <RedirectOnError to="..">
            <LoadProgram eventId={eventId}>
                <LoadSpeakers eventId={eventId}>
                    <LoadMeetings eventId={eventId}>
                        <Switch>
                            <Route path={`${props.match.path}/speakers`} component={speakersRoutes} />
                            <Route path={`${props.match.path}/:date/:tab`} component={scheduleRoutes} />
                            <Redirect from={`${props.match.path}/:date`} to={`${props.match.path}/:date/${defaultTab}`} />
                            <Route path={`${props.match.path}`} exact component={EventScheduleDefaultRoute} />
                            <Redirect to={`${props.match.path}`} />
                        </Switch>
                    </LoadMeetings>
                </LoadSpeakers>
            </LoadProgram>
        </RedirectOnError>
    );
};
